import Image from "next/image";
import Head from "next/head";
import Link from "next/link";

export default function Vehicules() {
  const vehicles = [
    {
      name: "Tesla Model Y",
      description:
        "Un SUV électrique performant offrant confort, technologie avancée et respect de l'environnement.",
      image: "/images/car55.jpeg",
    },
    {
      name: "Mercedes Classe V",
      description:
        "Un van de luxe spacieux, parfait pour les groupes et les voyages d'affaires avec style et confort.",
      image: "/images/Mercedes_ClassV22.jpg",
    },
    {
      name: "Mercedes Classe S",
      description:
        "Un van de luxe spacieux, parfait pour les groupes et les voyages d'affaires avec style et confort.",
      image: "/images/class_s1.jpg",
    },

    // Ajoutez d'autres véhicules si besoin
  ];

  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <Head>
        <title>Nos Véhicules – MonTransfert Sàrl</title>
      </Head>

      {/* Banner */}
      <div className="relative w-full h-[400px]">
        <Image
          src="/images/vehicules-banner.jpg"
          alt="Nos véhicules"
          fill
          className="object-cover"
          quality={100}
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-6">
          <h1 className="text-5xl font-bold">Nos Véhicules</h1>
          <p className="mt-4 text-lg max-w-2xl">
            Découvrez notre flotte moderne et confortable, adaptée à tous vos besoins.
          </p>
        </div>
      </div>

      {/* Vehicles Grid */}
      <section className="max-w-7xl mx-auto w-[90%] py-12 grid grid-cols-1 md:grid-cols-3 gap-10 flex-grow">
        {vehicles.map((vehicle, idx) => (
          <div key={idx} className="shadow-lg rounded-lg overflow-hidden bg-white">
            <div className="relative w-full h-64">
              <Image
                src={vehicle.image}
                alt={vehicle.name}
                fill
                className="object-cover"
                quality={90}
              />
            </div>
            <div className="p-6">
              <h2 className="text-2xl font-semibold mb-2">{vehicle.name}</h2>
              <p className="text-gray-700">{vehicle.description}</p>
            </div>
          </div>
        ))}
      </section>

     {/* Reservation Link */}
<div className="max-w-7xl mx-auto w-[90%] text-center py-12">
  <Link
    href="/"
    className="inline-block bg-[#deba91] hover:bg-[#b59466] text-white font-semibold py-4 px-8 rounded-lg transition-colors duration-300"
  >
    Réserver votre véhicule
  </Link>
</div>
    </div>
  );
}
